export default function showMore() {


    const showMore = document.querySelector('.js-slider-car-model-show');
    const showMoreMenu = document.querySelector('.js-new-slide-menu-more');

    if ( showMore ) {
        showMore.addEventListener('click',function(){
            this.style.display = 'none';
            document.querySelector('.swiper-wrapper-overflow')?.classList.remove("swiper-wrapper-overflow");
        });
    }


    //
    
    if ( showMoreMenu ) {
        showMoreMenu.addEventListener('click',function(){
            this.style.display = 'none';
            document.querySelector('.header-mobile__slide-menu-col_brands-hidden')?.classList.remove("header-mobile__slide-menu-col_brands-hidden");
        });
    }


}